import styled from 'styled-components'
export const Wrapper = styled.div`
  font-family: inter;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    height: auto;
    margin-top: 30px;
  }
`
export const LoginWrapper = styled.div`
  width: 50% !important;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100% !important;
    height: auto;
  }
  .welcome {
    padding: 0px 100px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 0px 20px;
    }

    h1 {
      font-style: normal;
      font-weight: 600;
      font-size: 36px;
      line-height: 40px;
      letter-spacing: 0.25px;
      color: ${({ theme }) => theme.colors.Cmk};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 24px !important;
      }
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      letter-spacing: -0.048px;
      color: ${({ theme }) => theme.colors.DarkCyan};
      margin-top: -10px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 14px !important;
      }
    }
  }
`
export const FormWrapper = styled.form`
  width: 100%;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    margin-bottom: 300px;
  }

  .each-form {
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    padding: 0px 100px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding: 0px 20px;
    }
    .to-left {
      float: right;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.secondPrimary};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 12px;
      }
    }
    .to-center {
      text-align: center;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.secondPrimary};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 12px;
      }
    }
    span {
      color: ${({ theme }) => theme.colors.black};
    }
  }
  .revert {
    margin-top: -20px;
  }
  label {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
    padding-bottom: 10px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: 12px;
    }
  }
`
export const PasswordContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  .img {
    position: absolute;
    right: 18px;
    cursor: pointer;
    font-size: 20px;
  }
`
